import { Component, OnInit } from '@angular/core';
import { FilestoreService } from '../filestore.service';
import { FileStoreOperationLog } from 'core-lib';
import { DynamicDialogComponent, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'lib-filestore-operation-log',
    templateUrl: './filestore-operation-log.component.html',
    styleUrl: './filestore-operation-log.component.scss',
    standalone: false
})
export class FilestoreOperationLogComponent implements OnInit {

  logs: FileStoreOperationLog[] = [];
  storeId: string;
  constructor(private fileStoreService: FilestoreService, private dialogConfig: DynamicDialogComponent) {

    this.storeId = dialogConfig.data.storeId;
  }
  ngOnInit(): void {
    this.fileStoreService.loadOperationLogs(this.storeId).subscribe((logs) => {
      this.logs = logs;
    });
  }

}
